import { mapGetters } from "vuex";
import confirmationPageMixin from "../mixin";

export default {
  mixins: [confirmationPageMixin],
  computed: {
    ...mapGetters("app", ["isStripeEnabled"]),
  },
};
